<template>
  <div class="pt-60 pb-24">
    <div class="text-left container mx-auto">
      <h1 class="custom-heading h-custom-color">Všeobecné obchodní podmínky</h1>
      <p class="p-custom-color custom-paragraph mr-20">
        Poslední aktualizace 18. 10. 2026
      </p>

      <h1 class="custom-heading h-custom-color mt-20">1. Poskytovatel a působnost podmínek</h1>
      <ol class="list-decimal ml-10">
        <li>
          Poskytovatelem služby je HostNow s.r.o., IČO: 21788693, DIČ: CZ21788693,
          se sídlem Třeboňská 530/2, 140 00 Praha 4 - Michle, Česká
          republika, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze,
          oddíl C, vložka 406087 (dále jen „HostNow“ nebo „poskytovatel“).
        </li>
        <li>
          Kontaktní e-mail a jednotné elektronické kontaktní místo je
          <a class="text-blue-800 hover:underline" href="mailto:info@hostnow.cz">info@hostnow.cz</a>.
          Zákazníci mohou využít také ticketový systém v administračním rozhraní.
          ID datové schránky poskytovatele je 6znwuvh. Komunikace je možná v češtině,
          slovenštině a angličtině.
        </li>
        <li>
          Tyto všeobecné obchodní podmínky (dále jen „VOP“) podle § 1751 zákona
          č. 89/2012 Sb., občanského zákoníku, upravují poskytování hostingových
          a souvisejících služeb zákazníkovi. Zvláštní
          <router-link class="text-blue-800 hover:underline" to="/podmienky-opakovanych-platieb">
            podmínky opakovaných plateb
          </router-link>
          jsou součástí smlouvy, pokud zákazník zvolí placený plán s opakovanou platbou.
        </li>
        <li>
          Spotřebitelem je fyzická osoba, která uzavírá smlouvu mimo rámec své
          podnikatelské činnosti nebo samostatného výkonu povolání. Ustanovení těchto
          VOP nesmí omezit práva, která spotřebiteli přiznávají kogentní právní předpisy.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">2. Účet, objednávka a uzavření smlouvy</h1>
      <ol class="list-decimal ml-10">
        <li>
          Zákazník musí uvádět pravdivé a aktuální údaje, chránit přístupové údaje
          a bez zbytečného odkladu oznámit jejich zneužití. Jeden zákazník může mít
          jeden účet, neschválí-li podpora výjimku. Osoba mladší 18 let může službu
          používat pouze se souhlasem zákonného zástupce.
        </li>
        <li>
          Před odesláním objednávky může zákazník zkontrolovat a opravit zadané údaje,
          zvolený plán, měnu, cenu a fakturační údaje. Objednávku odešle tlačítkem,
          které výslovně uvádí povinnost platby, jde-li o placený plán.
        </li>
        <li>
          U bezplatného plánu je smlouva uzavřena vytvořením projektu. U placeného
          plánu je smlouva uzavřena přijetím platby a potvrzením objednávky HostNow.
          Do potvrzení může HostNow objednávku odmítnout zejména pro nedostupnost
          plánu, neplatné údaje, bezpečnostní riziko nebo rozpor s právními předpisy.
        </li>
        <li>
          Smlouva se uzavírá elektronicky v českém jazyce. HostNow ukládá údaje
          o objednávce, přijatém znění podmínek a platbě. Zákazník může požádat
          podporu o jejich kopii.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">3. Popis a poskytování služby</h1>
      <ol class="list-decimal ml-10">
        <li>
          Hosting umožňuje zákazníkovi provozovat webové stránky a podle zvoleného
          plánu využívat úložiště, databáze, FTP účty, subdomény, SSL, zálohy,
          plánované úlohy a další funkce uvedené v nabídce plánu.
        </li>
        <li>
          Konkrétní parametry a limity služby určuje nabídka zobrazená před objednávkou.
          Funkce označené jako neomezené podléhají přiměřenému užívání sdílené
          infrastruktury a nesmějí nepřiměřeně omezovat ostatní zákazníky.
        </li>
        <li>
          Placený projekt je zpřístupněn po potvrzení platby a dokončení technického
          zřízení. Bezplatný projekt je zpravidla zřízen ihned. Je-li zřízení opožděno
          nebo selže, zákazník může kontaktovat podporu; tím nejsou dotčena jeho
          zákonná práva.
        </li>
        <li>
          Doménové jméno není součástí služby, není-li výslovně uvedeno jinak.
          Zákazník odpovídá za oprávnění doménu používat a za správné nastavení DNS.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">4. Ceny, DPH a doklady</h1>
      <ol class="list-decimal ml-10">
        <li>
          Ceny plánů jsou stanoveny bez DPH. Před závazným odesláním objednávky
          HostNow zobrazí cenu bez DPH, sazbu a částku DPH a celkovou cenu včetně DPH
          v měně CZK nebo EUR. Pro spotřebitele je rozhodující zobrazená celková cena.
        </li>
        <li>
          DPH se určuje podle českých a unijních pravidel, fakturační země zákazníka,
          aktuální sazby, režimu OSS a platnosti DIČ pro DPH. U oprávněného zákazníka
          z jiného členského státu EU může být použit režim přenesení daňové povinnosti.
        </li>
        <li>
          Zákazník odpovídá za správnost fakturační adresy, země a DIČ pro DPH a musí
          jejich změnu bezodkladně uložit v nastavení. Změna těchto údajů může změnit
          částku další platby. HostNow ověřuje DIČ pro DPH v příslušných veřejných
          systémech; nelze-li nárok na přenesení daňové povinnosti ověřit, uplatní DPH.
        </li>
        <li>
          Slevový poukaz se použije pouze za podmínek uvedených u poukazu, nelze jej
          směnit za peníze a jeho použitím může zaniknout právo použít jej znovu.
        </li>
        <li>
          Úhrada probíhá prostřednictvím platební brány GoPay. Daňový doklad poskytne
          HostNow elektronicky po přijetí platby nebo na vyžádání prostřednictvím podpory.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">5. Předplatné a opakované platby</h1>
      <ol class="list-decimal ml-10">
        <li>
          Placený plán je předplácen na měsíční období. První platbou kartou zákazník
          založí opakovanou platbu GoPay typu ON_DEMAND. Další platbu iniciuje HostNow
          po skončení uhrazeného období a po přepočtu aktuální ceny a DPH.
        </li>
        <li>
          Částka další platby je variabilní. Pokud se změní cena plánu, fakturační
          země, sazba DPH, daňový režim nebo platnost DIČ pro DPH a výsledná částka
          se liší od poslední platby, HostNow změnu oznámí e-mailem nejméně sedm
          pracovních dnů před provedením platby.
        </li>
        <li>
          Jedna měsíční opakovaná platba nepřesáhne 500 EUR nebo 12 500 CZK včetně DPH.
          Oprávnění platí nejvýše pět let nebo do jeho dřívějšího zrušení.
        </li>
        <li>
          Podrobnosti o založení, změně, zrušení a uchování důkazu souhlasu stanoví
          samostatné
          <router-link class="text-blue-800 hover:underline" to="/podmienky-opakovanych-platieb">
            podmínky opakovaných plateb
          </router-link>.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">6. Změna plánu, zrušení a odstranění projektu</h1>
      <ol class="list-decimal ml-10">
        <li>
          Přechod z bezplatného na placený plán vyžaduje novou objednávku, platbu
          a souhlas s opakovanými platbami. Placený plán se použije na existující projekt.
        </li>
        <li>
          Přechod z placeného na bezplatný plán je okamžitý. HostNow zruší oprávnění
          k budoucím platbám a nevyužitá část uhrazeného období se nevrací. To neplatí,
          pokud právo na vrácení peněz vyplývá ze zákona, uznané reklamace nebo těchto VOP.
        </li>
        <li>
          Odstraněním placeného projektu se současně zruší budoucí opakované platby.
          Projekt, soubory, databáze a související technická data budou odstraněny;
          zákazník je proto musí předem exportovat. Zákonem vyžadované účetní,
          daňové a důkazní záznamy mohou zůstat zachovány.
        </li>
        <li>
          Pokud nelze oprávnění k opakované platbě bezpečně zrušit nebo se právě
          zpracovává platba či změna plánu, HostNow může dokončení změny nebo odstranění
          projektu dočasně zablokovat, aby zabránil další nebo duplicitní platbě.
        </li>
        <li>
          Neúspěšná opakovaná platba placené období neprodlouží. HostNow může po
          oznámení omezit placené funkce do obnovení platby; před odstraněním dat
          poskytne přiměřenou možnost nápravy, nevyžaduje-li bezpečnost nebo zákon
          okamžitý zásah.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">7. Právo spotřebitele odstoupit</h1>
      <ol class="list-decimal ml-10">
        <li>
          Spotřebitel může od smlouvy uzavřené na dálku odstoupit bez uvedení důvodu
          do 14 dnů od jejího uzavření. Odstoupení stačí v této lhůtě odeslat na
          <a class="text-blue-800 hover:underline" href="mailto:info@hostnow.cz">info@hostnow.cz</a>,
          datovou schránkou nebo prostřednictvím ticketového systému.
        </li>
        <li>
          Požádá-li spotřebitel výslovně o zahájení služby před uplynutím lhůty pro
          odstoupení a následně odstoupí, uhradí poměrnou část ceny za plnění poskytnuté
          do okamžiku odstoupení. Právo odstoupit zaniká po úplném poskytnutí služby
          pouze tehdy, pokud plnění začalo s předchozím výslovným souhlasem spotřebitele
          a spotřebitel vzal na vědomí zánik tohoto práva.
        </li>
        <li>
          Platby, které mají být v důsledku odstoupení vráceny, HostNow vrátí bez
          zbytečného odkladu, nejpozději do 14 dnů od odstoupení, stejným platebním
          prostředkem, pokud se strany nedohodnou jinak.
        </li>
      </ol>
      <div class="border rounded p-4 mt-4">
        <strong>Vzorové oznámení o odstoupení od smlouvy</strong>
        <p class="mt-3 mb-0">
          Adresát: HostNow s.r.o., Třeboňská 530/2, 140 00 Praha 4 - Michle,
          info@hostnow.cz. Oznamuji, že odstupuji od smlouvy o poskytnutí služby
          [název plánu a projekt], objednané dne [datum]. Jméno a příjmení spotřebitele,
          adresa, e-mail účtu, datum a podpis (pouze při listinném podání).
        </p>
      </div>

      <h1 class="custom-heading h-custom-color mt-20">8. Dostupnost, údržba a zálohy</h1>
      <ol class="list-decimal ml-10">
        <li>
          HostNow přijímá přiměřená technická a organizační opatření pro bezpečný
          a spolehlivý provoz. Není-li u plánu výslovně sjednána úroveň dostupnosti,
          není služba poskytována s pevnou SLA.
        </li>
        <li>
          Služba může být dočasně omezena z důvodu údržby, aktualizace, bezpečnostního
          incidentu, výpadku dodavatele nebo okolnosti mimo přiměřenou kontrolu HostNow.
          Plánovanou údržbu s významným dopadem oznámí HostNow předem, je-li to možné.
        </li>
        <li>
          Zálohy poskytované v rámci plánu mají rozsah a frekvenci uvedenou u plánu.
          Nenahrazují vlastní zálohu zákazníka. Zákazník odpovídá za pravidelné
          exportování dat, která potřebuje zachovat, zejména před změnou či odstraněním projektu.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">9. Pravidla používání a obsah zákazníka</h1>
      <ol class="list-decimal ml-10">
        <li>
          Zákazník odpovídá za svůj obsah, aplikace, licence, zabezpečení přístupových
          údajů a dodržování právních předpisů. Nesmí zasahovat do práv třetích osob
          ani používat službu k nezákonné činnosti.
        </li>
        <li>
          Zakázán je zejména malware, phishing, spam, neoprávněné útoky a skenování,
          porušování autorských práv, nezákonný hazard, obsah podporující násilí nebo
          nenávist vůči chráněným skupinám, materiály sexuálního zneužívání dětí,
          pornografický obsah, warez a jiné nezákonné zboží nebo služby.
        </li>
        <li>
          Hosting není určen jako veřejný download server, úložiště záloh nebo
          archiv souborů nesouvisejících s provozem webu. Zákazník nesmí bez souhlasu
          HostNow provozovat činnost s nepřiměřenými nároky na sdílené prostředky.
        </li>
        <li>
          Zákazník nesmí obcházet limity, narušovat infrastrukturu, zneužívat chyby
          ani získávat neoprávněný přístup. Zjištěnou bezpečnostní chybu oznámí podpoře
          a nebude ji dále zneužívat.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">10. Nezákonný obsah a omezení služby</h1>
      <ol class="list-decimal ml-10">
        <li>
          Oznámení údajně nezákonného obsahu lze zaslat na info@hostnow.cz s předmětem
          „Oznámení nezákonného obsahu“. Oznámení má obsahovat odůvodnění nezákonnosti,
          přesnou URL nebo jiné umístění obsahu, jméno a e-mail oznamovatele, nebrání-li
          tomu právní předpis, a prohlášení o přesvědčení, že informace jsou přesné a úplné.
        </li>
        <li>
          HostNow oznámení posoudí včas, pečlivě, nestranně a objektivně. Je-li znám
          kontakt oznamovatele, potvrdí přijetí a oznámí mu své rozhodnutí a dostupné
          možnosti nápravy.
        </li>
        <li>
          HostNow může odstranit obsah, omezit jeho dostupnost, pozastavit projekt
          nebo ukončit službu, je-li obsah nezákonný, porušuje-li tyto VOP nebo je-li
          zásah nezbytný k ochraně bezpečnosti a ostatních zákazníků. Zvolí přiměřené
          opatření s ohledem na závažnost a opakování porušení.
        </li>
        <li>
          Dotčenému zákazníkovi HostNow poskytne jasné odůvodnění omezení a informaci
          o možnosti podat námitku prostřednictvím podpory, ledaže sdělení zakazuje
          zákon, pokyn orgánu veřejné moci nebo by ohrozilo vyšetřování či bezpečnost.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">11. Vady, reklamace a náhrada výpadku</h1>
      <p>
        Práva spotřebitele z vadného plnění a vyřizování reklamací se řídí zejména
        občanským zákoníkem a zákonem č. 634/1992 Sb., o ochraně spotřebitele.
      </p>
      <ol class="list-decimal ml-10">
        <li>
          HostNow odpovídá spotřebiteli za to, že digitální služba po dobu trvání
          závazku odpovídá sjednaným a zákonným požadavkům. Zákazník oznámí vadu
          prostřednictvím ticketu nebo na info@hostnow.cz a uvede projekt, popis vady,
          čas jejího projevu a požadovaný způsob vyřízení.
        </li>
        <li>
          HostNow vydá potvrzení o reklamaci a odstraní oprávněně reklamovanou vadu
          v přiměřené době a bez nákladů zákazníka. Nelze-li vadu odstranit, opakuje-li
          se nebo jde-li o podstatné porušení smlouvy, má spotřebitel právo na
          přiměřenou slevu nebo odstoupení v rozsahu stanoveném zákonem.
        </li>
        <li>
          Reklamace digitální služby bude vyřízena v přiměřené době s ohledem na její
          povahu a účel. U ostatních spotřebitelských reklamací platí zákonná lhůta,
          není-li se spotřebitelem dohodnuta delší.
        </li>
        <li>
          Trval-li výpadek placené služby zaviněný HostNow nepřetržitě déle než
          12 hodin, může zákazník do jednoho měsíce požádat o poměrnou slevu nebo
          odpovídající prodloužení placeného období. Tím nejsou omezena zákonná práva.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">12. Odpovědnost</h1>
      <ol class="list-decimal ml-10">
        <li>
          HostNow odpovídá za újmu v rozsahu stanoveném právními předpisy. Nic v těchto
          VOP nevylučuje odpovědnost, kterou nelze platně vyloučit nebo omezit, zejména
          odpovědnost za újmu způsobenou úmyslně nebo z hrubé nedbalosti a zákonná
          práva spotřebitele.
        </li>
        <li>
          HostNow neodpovídá za závady způsobené obsahem, softwarem nebo nastavením
          zákazníka, nesprávným DNS, ztrátou přístupových údajů, útokem využívajícím
          nezabezpečenou aplikaci zákazníka nebo službou třetí strany mimo kontrolu HostNow.
        </li>
        <li>
          Zákazník nahradí HostNow újmu, kterou prokazatelně způsobil zaviněným
          porušením smlouvy nebo právních předpisů. Toto ustanovení nezakládá
          paušální pokutu ani neomezuje právo zákazníka bránit se proti požadavku.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">13. Trvání a ukončení smlouvy</h1>
      <ol class="list-decimal ml-10">
        <li>
          Smlouva se uzavírá na dobu neurčitou s měsíčními placenými obdobími,
          není-li u konkrétní služby uvedeno jinak. Zákazník ji může ukončit přechodem
          na bezplatný plán, odstraněním projektu nebo oznámením podpoře.
        </li>
        <li>
          HostNow může službu okamžitě omezit nebo ukončit při závažném porušení
          VOP, nezákonné činnosti, bezpečnostním ohrožení nebo na základě závazného
          pokynu orgánu veřejné moci. U odstranitelného porušení poskytne zpravidla
          přiměřenou lhůtu k nápravě.
        </li>
        <li>
          Z jiného než závažného důvodu může HostNow vypovědět placenou službu
          s oznámením alespoň 30 dnů předem a vrátí poměrnou část předplacené ceny,
          kterou již nebude možné čerpat. U bezplatné služby poskytne přiměřené
          oznámení a možnost exportu dat, dovolují-li to okolnosti.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">14. Komunikace a změny podmínek</h1>
      <ol class="list-decimal ml-10">
        <li>
          Smluvní komunikace probíhá elektronicky přes e-mail účtu a ticketový systém.
          Zákazník udržuje e-mailovou adresu aktuální a pravidelně ji kontroluje.
        </li>
        <li>
          HostNow může VOP změnit z důvodu změny práva, služby, technologie,
          bezpečnosti, nákladů nebo obchodního modelu. Změnu, která se dotkne
          existující placené služby, oznámí zákazníkovi nejméně 30 dnů před účinností,
          není-li nutná dřívější účinnost z právního nebo bezpečnostního důvodu.
        </li>
        <li>
          Nesouhlasí-li zákazník s podstatnou změnou, může před její účinností službu
          ukončit. Změna ceny opakované platby se oznamuje nejméně sedm pracovních dnů
          před platbou a neuplatní se zpětně na již uhrazené období.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">15. Ochrana osobních údajů</h1>
      <p>
        Zpracování osobních údajů, doby uchování, příjemce a práva zákazníků popisují
        samostatné
        <router-link class="text-blue-800 hover:underline" to="/podmienky-ochrany-sukromia">
          zásady ochrany osobních údajů
        </router-link>.
        Požadavek na výmaz nemá vliv na údaje, které musí HostNow uchovat podle zákona
        nebo pro ochranu právních nároků.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">16. Rozhodné právo a spotřebitelské spory</h1>
      <ol class="list-decimal ml-10">
        <li>
          Smlouva se řídí právem České republiky. U spotřebitele tím nejsou dotčena
          kogentní práva, která mu poskytuje právo země jeho obvyklého bydliště.
        </li>
        <li>
          Před zahájením sporu doporučujeme obrátit se na HostNow na info@hostnow.cz.
          Spotřebitel může podat návrh na mimosoudní řešení sporu u České obchodní
          inspekce, Štěpánská 796/44, 110 00 Praha 1,
          <a class="text-blue-800 hover:underline" href="https://coi.gov.cz/informace-o-adr/" target="_blank" rel="noopener">coi.gov.cz</a>.
        </li>
        <li>
          Neplatnost nebo neúčinnost jednotlivého ustanovení nemá vliv na ostatní
          ustanovení. Přednost mají individuální ujednání se zákazníkem a kogentní právo.
        </li>
        <li>
          Tyto VOP nabývají platnosti a účinnosti dne 18. 10. 2026 a nahrazují
          předchozí znění aktualizované dne 9. 8. 2024.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfUse",
  components: {},
  mounted() {
    window.scrollTo(0, 0);
  },
  metaInfo() {
    return { title: "Všeobecné obchodní podmínky" };
  },
};
</script>

<style scoped></style>
